import React from 'react';
import Utils from 'commons/utils';
import { SearchInputColumn } from 'components';
import { Button, Badge, Box } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import { DatePickerSearchColumn } from 'components';

export const getColumns = (handleRenegotiate, typeClient, handleSearchColumn, showPopUp) => [
  {
    id: 'code',
    numeric: false,
    disablePadding: false,
    label: <SearchInputColumn title="Mã" name="objClientCompany.code" onChange={handleSearchColumn} />,
    width: 10,
    sort: true,
    align: 'left',
    render: (row) => <>{row?.objClientCompany?.code}</>,
  },
  {
    id: 'name',
    numeric: true,
    disablePadding: false,
    label: <SearchInputColumn title="Khách hàng" name="objClientCompany.name" onChange={handleSearchColumn} />,
    align: 'left',
    width: '200px',
    render: (row) => <>{row?.objClientCompany?.name}</>,
  },
  {
    id: 'serviceName',
    numeric: true,
    disablePadding: false,
    label: <SearchInputColumn title="Dịch vụ" name="arrService.name" onChange={handleSearchColumn} />,
    width: '200px',
    align: 'left',
    render: (row) => (
      <>
        {row?.arrService?.map((service, index) => (
          <div key={index}>
            <CircleIcon color="primary" sx={{ fontSize: 10, marginRight: '5px' }} />
            {service.name}
          </div>
        ))}
      </>
    ),
  },
  {
    id: 'objClientCompanyPause',
    numeric: true,
    disablePadding: false,
    label: <SearchInputColumn title="Lý do tạm ngưng" name="objClientCompanyPause.reasonForSuspension" onChange={handleSearchColumn} />,
    align: 'left',
    render: (row) => <>{row?.objClientCompanyPause?.reasonForSuspension}</>,
  },
  {
    id: 'suspensionDate',
    numeric: true,
    disablePadding: false,
    label: (
      <>
        <div>Ngày tạm ngưng</div>
        <DatePickerSearchColumn
          name="objClientCompanyPause.suspensionDate"
          onChange={handleSearchColumn}
        />
      </>
    ),
    align: 'left',
    render: (row) => Utils.formatDateFn(row?.objClientCompanyPause?.suspensionDate),
  },
  {
    id: 'userSuspension',
    numeric: true,
    disablePadding: false,
    label: <SearchInputColumn title="Người chuyển" name="objClientCompanyPause.userSuspension" onChange={handleSearchColumn} />,
    align: 'left',
    render: (row) => <>{row?.objClientCompanyPause?.userSuspension}</>,
  },
  {
    id: 'tax_Code',
    numeric: true,
    disablePadding: false,
    label: <SearchInputColumn title="Mã Số Thuế" name="objClientCompany.tax_Code" onChange={handleSearchColumn} />,
    align: 'left',
    render: (row) => <>{row?.objClientCompany?.tax_Code}</>,
  },
  {
    id: 'arrAddress',
    numeric: true,
    disablePadding: false,
    label: <SearchInputColumn title="Địa Chỉ" name="objClientCompany.arrAddress" onChange={handleSearchColumn} />,
    align: 'left',
    render: (row) => Utils.showArrayInTale(row?.objClientCompany?.arrAddress),
  },
  {
    id: 'arrNumberPhone',
    numeric: true,
    disablePadding: false,
    label: <SearchInputColumn title="SĐT người đại diện" name="objClientCompany.arrNumberPhone" onChange={handleSearchColumn} />,
    align: 'left',
    render: (row) => Utils.showArrayInTale(row?.objClientCompany?.arrNumberPhone),
  },
  {
    id: 'arrFax',
    numeric: true,
    disablePadding: false,
    label: <SearchInputColumn title="Ứng dụng liên hệ" name="objClientCompany.arrFax" onChange={handleSearchColumn} />,
    align: 'left',
    render: (row) => Utils.showArrayInTale(row?.objClientCompany?.arrFax),
  },
  {
    id: 'email',
    numeric: true,
    disablePadding: false,
    label: <SearchInputColumn title="Email người đại diện" name="objClientCompany.email" onChange={handleSearchColumn} />,
    align: 'left',
    render: (row) => <>{row?.objClientCompany?.email}</>,
  },
  {
    id: 'foundingDate',
    numeric: true,
    disablePadding: false,
    label: (
      <>
        <div>Ngày thành lập</div>
        <DatePickerSearchColumn
          name="objClientCompany.foundingDate"
          onChange={handleSearchColumn}
        />
      </>
    ),
    align: 'left',
    render: (row) => Utils.formatDateFn(row?.objClientCompany?.foundingDate),
  },

  {
    id: 'companyType',
    numeric: true,
    disablePadding: false,
    label: <SearchInputColumn title="Loại CT" name="objClientCompany.companyType" onChange={handleSearchColumn} />,
    align: 'left',
    render: (row) => <>{row?.objClientCompany?.companyType}</>,
  },

  {
    id: 'loyaltyTypeName',
    numeric: true,
    disablePadding: false,
    label: <SearchInputColumn title="Loại KH" name="objClientCompany.loyaltyTypeName" onChange={handleSearchColumn} />,
    align: 'center',
    render: (row) => typeClient(row?.objClientCompany?.loyaltyTypeName),
  },
  {
    id: 'note',
    numeric: true,
    disablePadding: false,
    label: <SearchInputColumn title="Ghi Chú" name="objClientCompany.note" onChange={handleSearchColumn} />,
    align: 'left',
    render: (row) => <>{row?.objClientCompany?.note}</>,
  },
  {
    // Người phụ trách chính
    id: 'Sales',
    numeric: true,
    disablePadding: false,
    label: <SearchInputColumn title="Sales" name="arrMainUserobj.name" onChange={handleSearchColumn} />,
    align: 'left',
    render: (row) => (
      <>
        {row?.arrMainUserobj?.map((service, index) => (
          <div key={index}>
            <CircleIcon color="primary" sx={{ fontSize: 10, marginRight: '5px' }} />
            {service.name}
          </div>
        ))}
      </>
    ),
  },
  {
    // Người phụ trách phụ
    id: 'CS',
    numeric: true,
    disablePadding: false,
    label: <SearchInputColumn title="CS" name="arrSecondaryUserobj.name" onChange={handleSearchColumn} />,
    align: 'left',
    render: (row) => (
      <>
        {row?.arrSecondaryUserobj?.map((service, index) => (
          <div key={index}>
            <CircleIcon color="primary" sx={{ fontSize: 10, marginRight: '5px' }} />
            {service.name}
          </div>
        ))}
      </>
    ),
  },
  {
    id: 'actions',
    numeric: false,
    disablePadding: false,
    label: 'Thao tác',
    fixed: 'right',
    align: 'left',
    render: (row) => (
      <Box >
        <Button
          variant="contained"
          size="small"
          color="primary"
          sx={{
            borderRadius: '15px',
            textTransform: 'none',
            m: '5px',
            fontWeight: 'normal',
            padding: '4px 15px',
          }}
          onClick={() => window.showConfirm(() => handleRenegotiate(row), 'Đàm phán lại?')}
        >
          Đàm phán lại
        </Button>
        <Button
          variant="contained"
          size="small"
          color="error"
          sx={{
            borderRadius: '15px',
            textTransform: 'none',
            m: '5px',
            fontWeight: 'normal',
            padding: '4px 15px',
          }}
          onClick={() => showPopUp(row)}
        >
          Đổi phụ trách
        </Button>
      </Box>
    )
  },
];
